import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { SearchStateParameters } from '@api-proxies';
import { StateService } from '@services/http/clients/state.service';
import { GenericTypeAheadDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-state-form-editor',
    templateUrl: './report-state-form-editor.component.html',
    styleUrls: ['./report-state-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportStateFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent]
})
export class ReportStateFormEditorComponent extends FormEditorBase<number | null> {
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select State');
    labelText = input<string>('State');

    private readonly stateService = inject(StateService);

    selectedItem(): any | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: any): void {
        if (item) this.onSelectedItemsChange([item]);
        else this.onSelectedItemsChange([]);
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text?.trim()) {
            this.items.set([]);
            return;
        }
        const states = await this.stateService.search({ filterText: text } as SearchStateParameters);
        this.items.set(states);
    }

    protected override mapSelectedItemsToValue(): number | null {
        const item = this.selectedItem();
        return item?.id ?? null;
    }

    protected override mapValueToSelectedItems(value: number | null): any[] {
        if (!value) return [];
        const items = this.items() ?? [];
        const found = items.find((item) => Number(item.id) === Number(value));
        return found ? [found] : [];
    }
}
